import { render, staticRenderFns } from "./report-title.vue?vue&type=template&id=238c97c0&scoped=true"
import script from "./report-title.vue?vue&type=script&lang=js"
export * from "./report-title.vue?vue&type=script&lang=js"
import style0 from "./report-title.vue?vue&type=style&index=0&id=238c97c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238c97c0",
  null
  
)

export default component.exports